import thirdImg from "./thirdImg.jpg";
import "./styles.css";

export default function ThirdImage() {
    return (
        <img src={thirdImg} alt="Foto de Andres y Mafer" className="third-image"/>
    );
};